import React, { useEffect, useState } from 'react'
import { Button, Container } from '@mui/material';
import { Add } from 'iconsax-react';
import { getCategories } from "../../api/categoriesApi";
import styles from './categoriesStyles';
import SearchBar from '../../components/SharedComponents/SearchBar';
import Title from '../../components/SharedComponents/Title';
import GridContainer from '../../components/Categories/GridContainer';
import NewCategoryDialog from '../../components/Categories/NewCategoryDialog';
import useLogout from '../../hooks/auth/authHook.js';
import { notification } from '../../utils/Notifications.js';
import { usePermissions } from '../../hooks/permissions/usePermissions.js';

const Categories = () => {
  const [logout] = useLogout();
  const { hasAllPermissions } = usePermissions();

  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(null);

  const handleDialogOpen = (dialogName) => {
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  const fetchCategories = () => {
    setIsLoading(true);
    getCategories({validatePermissions: 'true', filterActive: 'false'})
      .then((response) => {
        if (response.data.status_Code === 200) {
          setCategories(response.data.ls_membership_types);
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener las categorias",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({ text: "Error de conexión, revisa tu conexión a internet", type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <Container style={styles.mainContainer}>
      <Title title="Categorías" />
      <SearchBar setSearch={setSearch}>
        {hasAllPermissions(["cat_crt", 'cat_vw']) && (<Button
          variant="contained"
          startIcon={<Add variant="Outline"/>}
          onClick={() => handleDialogOpen("NewCategory")}
          style={styles.addCategoryButton}
        >
          Agregar
        </Button>)}
      </SearchBar>

      <GridContainer search={search} categories={categories} isLoading={isLoading} setIsLoading={setIsLoading} fetchCategories={fetchCategories} />

      <NewCategoryDialog
        open={openDialog === "NewCategory"}
        onClose={handleDialogClose}
        onOpenDialog={handleDialogOpen}
        fetchCategories={fetchCategories}
      />
    </Container>
  );
}

export default Categories
